import common from './common.json';
import riskSimulator from './risk-simulator.json';
import dashboard from './dashboard.json';
import documentation from './documentation.json';
import entity from './entity.json';
import reservesMonitoring from './reserves-monitoring.json';
import alerting from './alerting.json';

export const en = {
  common,
  dashboard,
  documentation,
  entity,
  reservesMonitoring,
  riskSimulator,
  alerting,
};
